import React, {useState} from 'react';
import {observer} from 'mobx-react-lite';
import {useNavigate} from 'react-router-dom';
import appStore from '../../storage/AppStore';
import {getProduct} from '../../common/config';
import '../../common/club_search.css';

const PRIORITY = ['FOOTBALL', 'FUTSAL', 'BASKETBALL', 'BOXING', 'VOLLEYBALL', 'KYRGYZ'];

const ClubSearchHome = () => {
  const navigate = useNavigate();
  const registerClub = () => {
    if (Number(appStore.user?.id) > 0) {navigate('/add'); return;}
    const botName = (process.env.REACT_APP_TELEGRAM_BOT_USERNAME || (getProduct() === 'club1' ? 'clubnumberone_bot' : '')).replace(/^@/, '');
    if (!botName) {navigate('/add'); return;}
    const botUrl = `https://t.me/${botName}?start=register`;
    const telegram = window.Telegram?.WebApp;
    if (telegram?.initData && telegram?.openTelegramLink) telegram.openTelegramLink(botUrl);
    else window.open(botUrl, '_blank', 'noopener,noreferrer');
  };
  const isCourse = getProduct() === 'course1';
  const [name, setName] = useState('');
  const [city, setCity] = useState('');
  const [sport, setSport] = useState('');
  const sports = (Array.isArray(appStore.sports) ? appStore.sports : []).filter(item => item && item.id != null && item.name);
  const popular = [...sports].sort((a, b) => {
    const ia = PRIORITY.indexOf(String(a.id).toUpperCase());
    const ib = PRIORITY.indexOf(String(b.id).toUpperCase());
    return (ia < 0 ? 99 : ia) - (ib < 0 ? 99 : ib);
  }).slice(0, 6);

  const openSearch = (sportId = sport) => {
    const params = new URLSearchParams();
    if (name.trim()) params.set('name', name.trim());
    if (city.trim()) params.set('city', city.trim());
    if (sportId) params.set('sport_id', String(sportId));
    navigate(`/clubs/search${params.toString() ? `?${params.toString()}` : ''}`);
  };

  return (
    <section className="club-search-home" aria-label={appStore.tr.club_search_button}>
      <div className="csh-hero">
        <div className="csh-eyebrow">{appStore.tr.club_search_eyebrow}</div>
        <h1 className="csh-title">{isCourse ? appStore.tr.course_search_title : appStore.tr.club_search_title}</h1>
        <p className="csh-subtitle">{isCourse ? appStore.tr.course_search_subtitle : appStore.tr.club_search_subtitle}</p>
        <form className="csh-form" onSubmit={e => {e.preventDefault(); openSearch();}}>
          <label className="csh-field">
            <span className="csh-label">{appStore.tr.club_search_name}</span>
            <input className="csh-input" value={name} onChange={e => setName(e.target.value)} placeholder={appStore.tr.club_search_name_hint} maxLength={100}/>
          </label>
          <label className="csh-field">
            <span className="csh-label">{appStore.tr.club_search_city}</span>
            <input className="csh-input" value={city} onChange={e => setCity(e.target.value)} placeholder={appStore.tr.club_search_city_hint} maxLength={100}/>
          </label>
          <label className="csh-field">
            <span className="csh-label">{isCourse ? appStore.tr.course_search_subject : appStore.tr.club_search_sport}</span>
            <select className="csh-select" value={sport} onChange={e => setSport(e.target.value)}>
              <option value="">{isCourse ? appStore.tr.course_search_all_subjects : appStore.tr.club_search_all_sports}</option>
              {sports.map(item => <option key={item.id} value={item.id}>{item.icon ? `${item.icon} ` : ''}{item.name}</option>)}
            </select>
          </label>
          <button className="csh-btn" type="submit"><i className="pi pi-search" aria-hidden="true"/>{isCourse ? appStore.tr.course_search_button : appStore.tr.club_search_button}</button>
        </form>
      </div>

      {popular.length > 0 && <>
        <div className="csh-below">
          <h2 className="csh-heading">{appStore.tr.club_search_popular}</h2>
          <button type="button" className="csh-link" onClick={() => openSearch('')}>{appStore.tr.browse_all_clubs} <i className="pi pi-arrow-right" aria-hidden="true"/></button>
        </div>
        <div className="csh-sports">
          {popular.map(item => <button key={item.id} type="button" className="csh-sport" data-selected={sport === String(item.id)} onClick={() => {setSport(String(item.id)); openSearch(item.id);}}>
            <span className="csh-sport-icon" aria-hidden="true">{item.icon || '🏅'}</span>
            <span className="csh-sport-text">{item.name}</span>
          </button>)}
        </div>
      </>}

      <div className="csh-register">
        <div className="csh-register-info">
          <span className="csh-register-icon" aria-hidden="true"><i className="pi pi-building"/></span>
          <div><h2 className="csh-register-title">{appStore.tr.club_search_create_title}</h2><p className="csh-register-text">{appStore.tr.club_search_create_text}</p></div>
        </div>
        <button type="button" className="csh-register-btn" onClick={registerClub}>
          <i className="pi pi-plus-circle" aria-hidden="true"/>{isCourse ? appStore.tr.course_search_register : appStore.tr.club_search_register}
        </button>
      </div>
    </section>
  );
};

export default observer(ClubSearchHome);
